import { get, patch, post, type RequestOptions } from '@/api/client';
import type {
  TriageAssigneesParams,
  TriageAssigneesResponse,
  TriageDetail,
  TriageGuidance,
  TriageHuddle,
  TriageListFilters,
  TriageListResponse,
  TriageNoteRecord,
  TriagePatchBody,
} from './types';

export const triageApi = {
  getList: (filters?: TriageListFilters, options?: RequestOptions) =>
    get<TriageListResponse>('/api/triage', { ...filters }, options),

  getAssignees: (params?: TriageAssigneesParams, options?: RequestOptions) =>
    get<TriageAssigneesResponse>('/api/triage/assignees', { ...params }, options),

  getHuddle: (options?: RequestOptions) =>
    get<TriageHuddle>('/api/triage/huddle', undefined, options),

  getItem: (uuid: string, options?: RequestOptions) =>
    get<TriageDetail>(`/api/triage/${uuid}`, undefined, options),

  getGuidance: (uuid: string, options?: RequestOptions) =>
    get<TriageGuidance>(`/api/triage/items/${uuid}/guidance`, undefined, options),

  patchItem: (uuid: string, body: TriagePatchBody) =>
    patch<TriageDetail>(`/api/triage/${uuid}`, body),

  createNote: (uuid: string, text: string) =>
    post<TriageNoteRecord>(`/api/triage/${uuid}/notes`, { text }),
};
